import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

const DOKUMEN = [
  {
    testid: "lhkpn-button-kepala",
    href: "/lhkpn-kepala-lldikti7.pdf",
    label: "Lihat LHKPN Kepala LLDIKTI VII",
  },
  {
    testid: "lhkpn-button-kabag",
    href: "/lhkpn-kabag-umum-lldikti7.pdf",
    label: "Lihat LHKPN Kabag Umum LLDIKTI VII",
  },
  {
    testid: "lhkpn-button-elhkpn",
    href: "https://elhkpn.kpk.go.id/",
    label: "Akses e-LHKPN KPK",
  },
];

export default function Lhkpn() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Laporan Harta Kekayaan Penyelenggara Negara
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            LHKPN LLDIKTI VII
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 max-w-3xl space-y-8 text-[15px] leading-relaxed text-slate-600 md:text-base">
            <p data-testid="lhkpn-text-1">
              Laporan Harta Kekayaan Penyelenggara Negara (LHKPN) adalah
              dokumen yang berisi uraian terperinci seputar harta kekayaan,
              aset pribadi, penerimaan, dan pengeluaran milik penyelenggara
              negara.
            </p>
            <p data-testid="lhkpn-text-2">
              Penyelenggara negara yang dimaksud adalah pejabat perseorangan
              yang tengah bertugas di instansi negara dalam tingkat pusat
              maupun daerah. LHKPN merupakan wujud dari semangat dalam
              menjalankan roda pemerintahan yang akuntabel, transparan, dan
              terbebas dari praktik korupsi. Kini, pelaksanaan LHKPN dilakukan
              secara elektronik melalui e-LHKPN.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col gap-4 sm:flex-row">
            {DOKUMEN.map((d) => (
              <a
                key={d.testid}
                href={d.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={d.testid}
                className="inline-flex items-center justify-center rounded-full bg-[#1479BF] px-7 py-3.5 text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#0B2440]"
              >
                {d.label}
              </a>
            ))}
          </div>
        </Reveal>
      </main>
      <Footer compact />
    </div>
  );
}
